<section class="faq-panel" [ngClass]="{'not-ready': !ready}" *ngIf="data">
  <div class="faq-panel__content">
    <div class="faq-panel__top">
      <h2 *ngIf="data.title?.value" class="faq-panel__title" #titleEl>{{data.title.value}}</h2>
      <div *ngIf="data.description?.value" class="faq-panel__descr rte" [innerHTML]="data.description.value | safe" #descriptionEl></div>
    </div>

    <div class="faq-panel__items" *ngIf="data.items?.value">
      <div class="faq-panel__item" (click)="handleToggleItem(item)" *ngFor="let item of data.items.value; let i = index">
        <div class="collapsible" id="{{ item.anchor?.value }}">
          <div class="collapsible__item" [ngClass]="{'collapsible__item--opened': item.state === accordionItemState.opened}">
            <div class="collapsible__item-trigger" [style.color]="item.questionColor?.value">
              {{ item.question?.value }}
              <i class="icon icon-trigger" #iconTrigger></i>
            </div>
            <div class="collapsible__item-content rte"
              [@animation]="item.state"
              [style.color]="item.answerColor?.value"
              [innerHTML]="item.answer.value"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
